<template>
  <p>Registration for VIZBI 2016 is now closed.</p>
  <p>
    <strong>Registration Fees:</strong>
  </p>
  <table>
    <tbody>
      <tr>
        <td>Academia:</td>
        <td>450 Euro</td>
      </tr>
      <tr>
        <td>PhD Student:</td>
        <td>400 Euro</td>
      </tr>
      <tr>
        <td>Industry:</td>
        <td>675 Euro</td>
      </tr>
      <tr>
        <td>Virtual Participation:</td>
        <td>100 Euro</td>
      </tr>
      <tr>
        <td>Tutorials:</td>
        <td>100 Euro per tutorial</td>
      </tr>
    </tbody>
  </table>
  <h4>Virtual Participation</h4>
  <p>
    VIZBI 2016 virtual participants were able to access a live web stream of all scheduled talks
    during the main conference (not the tutorials). Virtual participants could also upload a short
    video screened during one of the Lightning Talk sessions &mdash; see the
    <router-link to="Posters#Virtual">Posters page</router-link> for details.
  </p>
</template>

<style scoped>
p:not(:first-child) {
  margin-top: 12px;
}
table {
  margin: 8px 0 1em 0;
}
td {
  padding: 2px 24px 2px 0;
}
</style>
